import { isBooleanControl, rankWith } from "@jsonforms/core";

export default rankWith(3, isBooleanControl);
